var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.onLine)?_c(_vm.layout,{tag:"component"}):_c('h6',[_vm._v(_vm._s(_vm.$t('offline')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }